var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 379.88 265.89",
    style: {
      enableBackground: "new 0 0 379.88 265.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#00A2E5;}\n\t.st2{fill:#7375CF;}\n\t.st3{fill:#EB001B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000176760921501981059440000014814716538503420605_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.33,30.66H45.55c-6.09,0-11.03,4.94-11.03,11.03v182.53c0,6.09,4.94,11.03,11.03,11.03h288.78 c6.09,0,11.03-4.94,11.03-11.03V41.68C345.36,35.59,340.42,30.66,334.33,30.66z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.6,173.42v-2.54h-0.63l-0.74,1.69l-0.74-1.69h-0.63v2.54h0.42v-1.9l0.74,1.69h0.53l0.74-1.69v1.9H293.6z  M289.37,173.42v-2.11h0.85v-0.42h-2.11v0.42h0.85v2.11H289.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.47,184.3H161.3V81.59h57.17V184.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M165,132.95c0-20.82,9.72-39.41,24.94-51.35c-11.09-8.77-25.15-13.95-40.36-13.95 c-36.03,0-65.3,29.27-65.3,65.3s29.27,65.3,65.3,65.3c15.22,0,29.27-5.18,40.36-13.95C174.72,172.36,165,153.76,165,132.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.61,132.95c0,36.03-29.27,65.3-65.3,65.3c-15.22,0-29.27-5.18-40.36-13.95 c15.22-11.94,24.94-30.54,24.94-51.35s-9.72-39.41-24.94-51.35c11.09-8.77,25.15-13.95,40.36-13.95 C266.34,67.64,295.61,96.91,295.61,132.95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/maestro.c2a6375be0f251c51669979a0668eb0f.svg";
export { ForwardRef as ReactComponent };